"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPluginArguments = exports.AddPluginOptions = void 0;
exports.AddPluginOptions = [
    {
        name: "api-plugin-type",
        type: "string",
        description: "Action type.",
        required: true,
        default: "new-api",
        choices: ["api-spec"],
    },
    {
        name: "openapi-spec-type",
        type: "string",
        description: "The type of the API spec.",
        required: true,
        choices: ["enter-url-or-open-local-file", "search-api"],
    },
    {
        name: "openapi-spec-location",
        type: "string",
        shortName: "a",
        description: "OpenAPI description document location.",
    },
    {
        name: "api-operation",
        type: "array",
        shortName: "o",
        description: "Select operation(s) Copilot can interact with.",
    },
    {
        name: "search-openapi-spec-query",
        type: "string",
        description: "Search OpenAPI Description Document",
    },
    {
        name: "select-openapi-spec",
        type: "string",
        description: "Select OpenAPI Description Document",
    },
    {
        name: "manifest-file",
        questionName: "manifest-path",
        type: "string",
        shortName: "t",
        description: "Specifies the app manifest file path.",
        required: true,
        default: "./appPackage/manifest.json",
    },
];
exports.AddPluginArguments = [];
//# sourceMappingURL=AddPluginOptions.js.map